export default "__VITE_ASSET__C7u24kgl__"